"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _DefinedUserRoles = _interopRequireDefault(require("./DefinedUserRoles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The CreateUserCommand model module.
 * @module model/CreateUserCommand
 * @version 1.1.3-alpha.1
 */
class CreateUserCommand {
  /**
   * Constructs a new <code>CreateUserCommand</code>.
   * @alias module:model/CreateUserCommand
   * @param email {String} 
   * @param password {String} 
   */
  constructor(email, password) {
    CreateUserCommand.initialize(this, email, password);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, email, password) {
    obj['email'] = email;
    obj['password'] = password;
  }

  /**
   * Constructs a <code>CreateUserCommand</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CreateUserCommand} obj Optional instance to populate.
   * @return {module:model/CreateUserCommand} The populated <code>CreateUserCommand</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CreateUserCommand();
      if (data.hasOwnProperty('email')) {
        obj['email'] = _ApiClient.default.convertToType(data['email'], 'String');
      }
      if (data.hasOwnProperty('password')) {
        obj['password'] = _ApiClient.default.convertToType(data['password'], 'String');
      }
      if (data.hasOwnProperty('role')) {
        obj['role'] = _DefinedUserRoles.default.constructFromObject(data['role']);
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>CreateUserCommand</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CreateUserCommand</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of CreateUserCommand.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
      throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
    }
    // ensure the json data is a string
    if (data['password'] && !(typeof data['password'] === 'string' || data['password'] instanceof String)) {
      throw new Error("Expected the field `password` to be a primitive type in the JSON string but got " + data['password']);
    }
    return true;
  }
}
CreateUserCommand.RequiredProperties = ["email", "password"];

/**
 * @member {String} email
 */
CreateUserCommand.prototype['email'] = undefined;

/**
 * @member {String} password
 */
CreateUserCommand.prototype['password'] = undefined;

/**
 * @member {module:model/DefinedUserRoles} role
 */
CreateUserCommand.prototype['role'] = undefined;
var _default = exports.default = CreateUserCommand;